<template>
  <v-navigation-drawer
    v-model="drawer"
    class="grey lighten-4"
    :clipped="clipped"
    :floating="floating"
    :mini-variant="mini"
    :permanent="type === 'permanent'"
    :temporary="type === 'temporary'"
    app
    overflow
  >
    <v-img v-if="!clipped" class="primary align-end" height="64" src="@/assets/logo.png"></v-img>
    <v-list>
      <v-list-item router to="/auth/update">
        <DrawerProfile :user="currentUser" />
      </v-list-item>
      <span v-for="(item, i) in routes" :key="i">
        <v-divider v-if="item.meta.divider" dark class="my-4"></v-divider>
        <v-layout v-if="item.meta.heading" align-center>
          <v-flex xs6>
            <v-subheader v-if="item.meta.heading">
              {{
              item.meta.heading
              }}
            </v-subheader>
          </v-flex>
        </v-layout>
        <v-list-item router :to="item.path">
          <v-list-item-action>
            <v-icon>{{ item.meta.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">
              {{
              item.meta.title
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </span>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import DrawerProfile from "@/components/users/miniProfile.vue";

export default {
  name: "Drawer",
  components: {
    DrawerProfile
  },
  props: {
    toDrawer: {
      type: Boolean,
      default: false
    }
  },

  data: () => {
    return {
      drawer: true,
      clippedLeft: true,
      model: null,
      type: "default (no property)",
      clipped: true,
      floating: false,
      mini: false,
      routes: null
    };
  },

  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  watch: {
    toDrawer(v) {
      this.drawer = v;
    },
    drawer(v) {
      this.$emit("fromDrawer", v);
    },
    currentUser() {
      this.getUserAndMenu();
    }
  },
  mounted() {
    this.getUserAndMenu();
  },
  methods: {
    getUserAndMenu() {
      this.routes = this.$router.options.routes.filter(this.filterMenus);
    },
    rolesCheck(route) {
      // get roles from user
      let currentUser = this.$store.getters.currentUser;
      let userRoles = currentUser ? currentUser.roles : [];

      // get roles from route meta
      let requiredRoles = route.meta.roles;

      if (requiredRoles && requiredRoles.length > 0) {
        return requiredRoles.some(role => userRoles.includes(role));
      } else {
        return true;
      }
    },
    filterMenus(route) {
      let visible = !route.meta.hidden;
      let accessable = this.rolesCheck(route);
      if (visible && accessable) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style></style>
